<template lang='pug' src='./custom-home-testimonials.pug'></template>

<script>
import SliderTestimonials from 'components/slider/slider-testimonials/slider-testimonials'

export default {
  props: ['props'],
  data () {
    return {
      titleActive: false,
      active: false
    }
  },
  components: {
    SliderTestimonials
  }
}
</script>



// WEBPACK FOOTER //
// custom-home-testimonials.vue?1cf2ff04